/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react'
import {SCORM} from 'pipwerks-scorm-api-wrapper';

// if(debug) console.log enabled/disabled
const debug = false;


const translate = {
    "scorm12":{
        "suspend_data":"cmi.suspend_data",
        "lesson_status":"cmi.core.lesson_status",
        "lesson_location":"cmi.core.lesson_location",
        "complete":"completed",
        "incomplete":"incomplete"
    },
    "scorm2004":{
        "suspend_data":"cmi.suspend_data",
        "lesson_status":"cmi.completion_status",
        "lesson_location":"cmi.location",
        "success_status":"cmi.success_status",
        "complete":"completed",
        "incomplete":"incomplete",
        "int_id":"cmi.interactions.n.id",
        "int_type":"cmi.interactions.n.type",
        "int_weight":"cmi.interactions.n.weighting",
        "int_choice":"cmi.interactions.n.learner_response",
        "int_result":"cmi.interactions.n.result",
        "int_description":"cmi.interactions.n.description",
        "score_scaled":"cmi.score.scaled",
        "score":"cmi.score.raw",
        "score_max":"cmi.score.max",
        "score_min":"cmi.score.min",
        "interaction_count":"cmi.interactions._count"
    }
};

const SCORMComponent = props => {

    const [connected, setConnected] = useState(false);

    const commit = () => {
        if(debug)console.log('Data commit attempt');
        SCORM.save();
        if(debug)console.log('Data commit result:', SCORM.debug.getCode());
    }

    const get = (key) => {
        key = translate[props.version][key];
        return SCORM.get(key);    
    }

    const set = (key, val, autoCommit = false) => {
        if(debug)console.log('Tracking.set()');
        const translated = translate[props.version][key];
        if(translated !== undefined){
            key = translated;
        }
        if(debug)console.log('Data save attempt', key, ':', val);

        SCORM.set(key, val);
        
        if(debug)console.log('Data save result:', SCORM.debug.getCode());
        if(autoCommit){
            commit();
        }
        return SCORM.debug.getCode();
    }
    
  

    const getSuspendData = () =>{
        const suspend = get('suspend_data');
        if(suspend == null || suspend === '' || suspend === undefined || suspend === 'null'){
            return false;
        }
        return JSON.parse(suspend);
    }

    useEffect(() => {
        //on init
        if(debug) console.log("TRACKING init")

        let success = false;
        try{
            success = SCORM.init();
        }catch (e){
            if(debug)console.log('TRACKING scorm init error:', e);
        }
        
        setConnected(success);

        if(!success){
            if(debug)console.log('TRACKING: SCORM init failure, halting')
        }
        
    }, [])

    useEffect(()=> {
        //on connection change
        if(connected){
            if(debug)console.log("TRACKING: SCORM connected")
        
            let location = get('lesson_location');
            if(!(location == null || location === '' || location === undefined || location === 'null')){
                location = JSON.parse(location);
            }
            const bookmark = {
                lessonLocation:location,
                suspendData:getSuspendData()
            }
            props.onInit(bookmark)
            
            window.onbeforeunload = function(){
                SCORM.quit();
                // SCORM.save();
            }
        }else{
            if(debug)console.log('TRACKING SCORM not connected')
        }
    }, [connected])

    useEffect(() => {
        //on user location/progress change
        if(!connected) return;

        if(debug)console.log("TRACKING index change detected")
        const bookmark = props.currentLocation;
        set('lesson_location', JSON.stringify(bookmark))
        set('suspend_data', JSON.stringify(props.progress))
    }, [props.currentLocation, props.progress])

    useEffect(() => {
        //on course completion change
        if(!connected) return;

        if(props.scoComplete){
            if(debug)console.log("TRACKING SCO completion detected")
            set('lesson_status', translate[props.version]['complete']);
            if(props.scoScored){
                if(props.version === 'scorm2004'){
                    set('success_status', 'passed');
                    commit();
                    try {
                        // check if is initialized
                       window.close()
                    } catch (error) {
                        
                    }
                }else{
                    set('success_status', 'failed');                
                }
            }else{
                set('success_status', 'passed');
                commit();
                try {
                    window.close()
                } catch (error) {
                    
                }
            }
        }
        commit();
      
    }, [props.scoComplete])

    useEffect(() => {
        if(props.quit && connected){
            SCORM.quit();
            window.close();
        }
    }, [props.quit])
    
    return (
        <></>
    )
}

export default SCORMComponent